import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from '../axiosInstance';
import {
  errorResponseParser,
  successResponseParser,
} from '../../utils/handlers';

//fetch meeting type
export const fetchMeetingType = createAsyncThunk(
  'fetchMeetingType',
  async (data, { getState, rejectWithValue, dispatch }) => {
    const { userInfo } = getState().auth;
    const { companyId } = userInfo;
    try {
      const response = await axiosInstance.get(`/getMeetingType`, {
        params: {
          expenseId: data?.expenseId,
          activityDate: data?.activityDate,
          companyId: companyId,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(errorResponseParser(error, dispatch));
    }
  }
);

export const getExpenseDetail = createAsyncThunk(
  'getExpenseDetail',
  async (
    { activityDate, expenseId },
    { getState, rejectWithValue, dispatch }
  ) => {
    const { userInfo } = getState().auth;
    const { companyId } = userInfo;
    try {
      const response = await axiosInstance.get(`/getExpenseDetailForDay`, {
        params: {
          expenseId: expenseId,
          activityDate: activityDate,
          companyId: companyId,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(errorResponseParser(error, dispatch));
    }
  }
);

export const getCities = createAsyncThunk(
  'getCities',
  async (_, { getState, rejectWithValue, dispatch }) => {
    const { userInfo } = getState().auth;
    const { employeeId, companyId } = userInfo;
    try {
      const response = await axiosInstance.get(`/getCitiesForDropDown`, {
        params: {
          employeeId: employeeId,
          companyId: companyId,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(errorResponseParser(error, dispatch));
    }
  }
);

export const getCityDistance = createAsyncThunk(
  'getCityDistance',
  async (data, { getState, rejectWithValue, dispatch }) => {
    const { userInfo } = getState().auth;
    const { employeeId, companyId } = userInfo;
    const { fromCityId, toCityId, expenseIdFor, activityDateFor } =
      data;
    try {
      const response = await axiosInstance.get(`/getCityDistance`, {
        params: {
          fromCityId: fromCityId,
          toCityId: toCityId,
          employeeId: employeeId,
          companyId: companyId,
          expenseId: expenseIdFor,
          activityDate: activityDateFor,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(errorResponseParser(error, dispatch));
    }
  }
);

export const getModeOfTransport = createAsyncThunk(
  'getModeOfTransport',
  async (_, { getState, rejectWithValue, dispatch }) => {
    const { userInfo } = getState().auth;
    const { companyId } = userInfo;
    try {
      const response = await axiosInstance.get(
        `/SFCTerritoryModeOfTransport?gradeId=1&type=expense`,
        {
          params: {
            companyId: companyId,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(errorResponseParser(error, dispatch));
    }
  }
);

export const getAutoCategory = createAsyncThunk(
  'getAutoCategory',
  async (data, { getState, rejectWithValue, dispatch }) => {
    const { userInfo } = getState().auth;
    const { employeeId, companyId } = userInfo;
    const { distance, designationId, activityDateFor, fromCityId, toCityId, expenseId } = data;
    try {
      const response = await axiosInstance.get(`/getAutoCategory`, {
        params: {
          employeeId: employeeId,
          effectiveDate: activityDateFor,
          distance: distance,
          designationId: designationId,
          companyId: companyId,
          fromCityId: fromCityId,
          toCityId: toCityId,
          expenseId: expenseId
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(errorResponseParser(error, dispatch));
    }
  }
);

export const getSfcFareAndAllowance = createAsyncThunk(
  'getSfcFareAndAllowance',
  async (data, { getState, rejectWithValue, dispatch }) => {
    const { userInfo } = getState().auth;
    const { employeeId, companyId } = userInfo;
    try {
      const res = await axiosInstance.get(`/SFCFareAndAllowance`, {
        params: {
          fromCityId: data?.fromCityId,
          toCityId: data?.toCityId,
          categoryId: data?.categoryId,
          effectiveDate: data?.effectiveDate,
          employeeId: employeeId,
          companyId: companyId,
          expenseId: data?.expenseId,
          activityDate: data?.effectiveDate.split("-").reverse().join("-"),
          totalDistance: data?.totalDistance
        },
      });
      return successResponseParser(res);
    } catch (error) {
      return rejectWithValue(errorResponseParser(error, dispatch));
    }
  }
);

export const getExpenseTotal = createAsyncThunk(
  'getExpenseTotal',
  async (data, { getState, rejectWithValue, dispatch }) => {
     const { userInfo } = getState().auth;
    const { companyId } = userInfo;
    try {
      const res = await axiosInstance.get(`/getExpenseTotal`, {
        params: {
          expenseId: data?.expenseId,
          activityDate: data?.activityDate,
          fare: data?.fare,
          allowance: data?.allowance,
          companyId: companyId
        },
      });
      return successResponseParser(res);
    } catch (error) {
      return rejectWithValue(errorResponseParser(error, dispatch));
    }
  }
);

export const expenseGeneratorFinalSubmit = createAsyncThunk(
  'expenseGeneratorFinalSubmit',
  async (data, { getState,rejectWithValue, dispatch }) => {
    const { userInfo } = getState().auth;
    const { employeeId, companyId  } = userInfo;
    try {
      const res = await axiosInstance.post(`/expenseSaveDaywise`, { ...data, employeeId: employeeId, companyId: companyId });
      return successResponseParser(res);
    } catch (error) {
      return rejectWithValue(errorResponseParser(error, dispatch));
    }
  }
);

export const getMeetingAllowance = createAsyncThunk(
  'getMeetingAllowance',
  async (data, { getState, rejectWithValue, dispatch }) => {
    const { userInfo } = getState().auth;
    const { employeeId, companyId } = userInfo;
    try {
      const res = await axiosInstance.get(`/getMeetingAllowance`, {
        params: {
          employeeId: employeeId,
          expenseId: data?.expenseId,
          activityDate: data?.activityDate,
          meetingTypeID: data?.meetingTypeID,
          companyId: companyId
        },
      });
      return successResponseParser(res);
    } catch (error) {
      return rejectWithValue(errorResponseParser(error, dispatch));
    }
  }
);


export const getOtherExpenseTypeValidate = createAsyncThunk(
  'getOtherExpenseTypeValidate',
  async (data, { getState, rejectWithValue, dispatch }) => {
    const { userInfo } = getState().auth;
    const { companyId } = userInfo;
    try {
      const res = await axiosInstance.post(`/otherExpenseTypeValidate`, {
          expenseTypeId: data?.expenseTypeId,
          amount: data?.amount,
          companyId: companyId
        });
      return successResponseParser(res);
    } catch (error) {
      return rejectWithValue(errorResponseParser(error, dispatch));
    }
  }
);

//create slice for my leap
export const expenseGenerator = createSlice({
  name: 'expenseGenerator',
  initialState: {
    isLoading: false,
    MeetingDataForDropdown: [],
    apiError: false,
    errorMessage: '',
    expenseDetailForDay: [],
    cities: [],
    cityDistanceDetail: {},
    modeOfTransport: [],
    isAutoCategory: '',
    isTotalDistance: null,
    isFareAndAllowance: {},
    isExpenseTotal: {},
    isFinalSubmit: false,
    isDataSubmitted: false,
    isMeetingAllowance: {},
    isFinalSubmitErrorMessage: '',
    isSaved: false,
    showUnsavedChangesPopup: false,
    isOtherExpenseTypeValidate: {},
    isOtherExpenseTypeValidateErrorMessage: {}
  },
  reducers: {
    resetValues: (state, action) => {
      state.cityDistanceDetail = {};
    },
    addTotalDistance: (state, action) => {
      state.isTotalDistance = action.payload;
    },
    resetFinalSubmit: (state) => {
      state.isFinalSubmit = false;
    },
    resetFinalSubmitErrorMessage: (state, action) => {
      state.isFinalSubmitErrorMessage = ''
    },
     resetOtherExpenseTypeValidate: (state, action) => {
      state.isOtherExpenseTypeValidate = {}
    },
    dataSubmitted: (state) => {
      state.isDataSubmitted = true;
    },
    setIsSaved: (state, action) => {
      state.isSaved = action.payload;
    },
    setShowUnsavedChangesPopup: (state, action) => {
      state.showUnsavedChangesPopup = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMeetingType.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchMeetingType.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.MeetingDataForDropdown = payload;
      })
      .addCase(fetchMeetingType.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.error.message;
        state.apiError = true;
      });

    //getExpenseDetail
    builder
      .addCase(getExpenseDetail.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getExpenseDetail.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.expenseDetailForDay = payload;
      })
      .addCase(getExpenseDetail.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.error.message;
        state.apiError = true;
      });

    //getCities
    builder
      .addCase(getCities.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCities.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.cities = payload;
      })
      .addCase(getCities.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.error.message;
        state.apiError = true;
      });

    //getCityDistance
    builder
      .addCase(getCityDistance.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCityDistance.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.cityDistanceDetail = payload;
      })
      .addCase(getCityDistance.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.error.message;
        state.apiError = true;
      });

    //getModeOfTransport
    builder
      .addCase(getModeOfTransport.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getModeOfTransport.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.modeOfTransport = payload;
      })
      .addCase(getModeOfTransport.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.error.message;
        state.apiError = true;
      });

    //getAutoCategory
    builder
      .addCase(getAutoCategory.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAutoCategory.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isAutoCategory = payload;
      })
      .addCase(getAutoCategory.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.error.message;
        state.apiError = true;
      });

    //getFareAndAllowance
    builder
      .addCase(getSfcFareAndAllowance.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getSfcFareAndAllowance.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isFareAndAllowance = payload;
      })
      .addCase(getSfcFareAndAllowance.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.error.message;
        state.apiError = true;
      });

    //getExpenseTotal
    builder
      .addCase(getExpenseTotal.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getExpenseTotal.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isExpenseTotal = payload;
      })
      .addCase(getExpenseTotal.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.error.message;
        state.apiError = true;
      });

      //isFinalSubmitted
      builder
      .addCase(expenseGeneratorFinalSubmit.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(expenseGeneratorFinalSubmit.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isFinalSubmit = true;
      })
      .addCase(expenseGeneratorFinalSubmit.rejected, (state, action) => {
        state.isLoading = false;
        state.isFinalSubmitErrorMessage = action.payload;
        state.apiError = true;
      });

        //getMeetingType
    builder
      .addCase(getMeetingAllowance.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getMeetingAllowance.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isMeetingAllowance = payload;
      })
      .addCase(getMeetingAllowance.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.error.message;
        state.apiError = true;
      });


      // getOtherExpenseTypeValidate
      builder
      .addCase(getOtherExpenseTypeValidate.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getOtherExpenseTypeValidate.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isOtherExpenseTypeValidate = payload;
      })
      .addCase(getOtherExpenseTypeValidate.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isOtherExpenseTypeValidateErrorMessage = payload
        state.apiError = true;
      });
  },
});

export const { resetValues, addTotalDistance, resetFinalSubmit, setFormValues, dataSubmitted, resetFinalSubmitErrorMessage, setIsSaved, setShowUnsavedChangesPopup, resetOtherExpenseTypeValidate } =
  expenseGenerator.actions;
export const expenseGeneratorReducer = expenseGenerator.reducer;
